var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.043,
    height: 23.159,
    viewBox: "0 0 21.043 23.159",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_18",
    "data-name": "Path 18",
    d: "M6.616,6H21.427a2.116,2.116,0,0,1,2.116,2.116V22.927a2.116,2.116,0,0,1-2.116,2.116H6.616A2.116,2.116,0,0,1,4.5,22.927V8.116A2.116,2.116,0,0,1,6.616,6Z",
    transform: "translate(-3.5 -2.884)",
    fill: "none",
    stroke: "#716f6f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_19",
    "data-name": "Path 19",
    d: "M24,3V7.232",
    transform: "translate(-9.246 -2)",
    fill: "none",
    stroke: "#716f6f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_20",
    "data-name": "Path 20",
    d: "M12,3V7.232",
    transform: "translate(-5.71 -2)",
    fill: "none",
    stroke: "#716f6f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_21",
    "data-name": "Path 21",
    d: "M4.5,15H23.543",
    transform: "translate(-3.5 -5.536)",
    fill: "none",
    stroke: "#716f6f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDate);
export default __webpack_public_path__ + "static/media/date.06efd42609769410c4d2ae819b9fde74.svg";
export { ForwardRef as ReactComponent };